module.exports = __webpack_public_path__ + "static/media/img-integration-01.dd102185.svg";